import { Tooltip, withStyles }  from '@material-ui/core';

const SubsectionTooltip = withStyles((theme) => ({
  tooltip: {
    padding: '7px 7px 2px 7px',
    backgroundColor: '#FFFFFF',
    fontSize: 13,
    border: '1px solid' + theme.palette.primary.main,
    '& p': {
      color: '#505050',
    },
    '&:before': {
      content: "' '",
      top: 'calc(50% - 6px)',
      left: '-20px',
      width: "1em",
      height: "1em",
      position: 'absolute',
      backgroundColor: '#FFF',
      marginLeft: '1em',
      transform: 'rotate(45deg)',
      borderColor: 'transparent transparent #694a8a #694a8a',
      borderStyle: 'solid',
      borderWidth: '1px',
    },
  },

}))(Tooltip);

export default SubsectionTooltip;



// WEBPACK FOOTER //
// ./src/components/SubsectionTooltip.js